import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PanelsPage from './pages/PanelsPage';
import PanelDetailPage from './pages/PanelDetailPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import SupportTicketsPage from './pages/SupportTicketsPage';
import NotificationsPage from './pages/NotificationsPage';
import PerfectPaymentMethodsPage from './pages/PerfectPaymentMethodsPage';
import AdminAccountsPage from './pages/AdminAccountsPage';
import BroadcastsPage from './pages/BroadcastsPage';
import BroadcastPanelsPage from './pages/BroadcastPanelsPage';
import DropCheckerPage from './pages/DropCheckerPage';

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              className: "bg-background text-foreground border border-border shadow-md rounded-md text-sm",
              style: {
                background: 'hsl(var(--background))',
                color: 'hsl(var(--foreground))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '0.375rem',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                padding: '12px 16px'
              },
              success: {
                iconTheme: { primary: 'hsl(var(--primary))', secondary: 'hsl(var(--primary-foreground))' }
              },
              error: {
                iconTheme: { primary: 'hsl(var(--destructive))', secondary: 'hsl(var(--destructive-foreground))' }
              }
            }}
          />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/panels" element={<ProtectedRoute><PanelsPage /></ProtectedRoute>} />
            <Route path="/panels/:id" element={<ProtectedRoute><PanelDetailPage /></ProtectedRoute>} />
            <Route path="/panels/:id/admins" element={<ProtectedRoute><AdminAccountsPage /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
            <Route path="/support-tickets" element={<ProtectedRoute><SupportTicketsPage /></ProtectedRoute>} />
            <Route path="/perfect-panel/payments" element={<ProtectedRoute><PerfectPaymentMethodsPage /></ProtectedRoute>} />
            <Route path="/broadcasts" element={<ProtectedRoute><BroadcastsPage /></ProtectedRoute>} />
            <Route path="/broadcasts/panels" element={<ProtectedRoute><BroadcastPanelsPage /></ProtectedRoute>} />
            <Route path="/drop-checker" element={<ProtectedRoute><DropCheckerPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
